import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.lg,
		padding: THEME.spacing.lg,
	},
	header: {
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		gap: THEME.spacing.md,
		flexWrap: 'wrap',
	},
	heading: {
		fontFamily: THEME.typography.fontFamilies.sora,
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.dark,
		margin: 0,
	},
	subheading: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		margin: `${THEME.spacing.xs}px 0 0`,
		maxWidth: '68ch',
	},
	controls: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.md,
		flexWrap: 'wrap',
	},
	searchInput: {
		flex: 1,
		minWidth: 220,
		maxWidth: 420,
	},
	selectionBar: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.md,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		backgroundColor: THEME.colors.background.main,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
	},
	selectionCount: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
		marginRight: 'auto',
	},
});
